<template>
  <div class="faq-page">
    <page-header
      heading="How can we help you?"
      desc="A quick way to know about KIPS virtual"
    />
    <section class="newFaq">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <h2>Frequently Asked Questions</h2>
          </div>

          <div class="col-md-12 faqSlab">
            <div class="faq-accordion" role="tablist">
              <div class="acrBox">
                <h4>General</h4>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-1 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>What is KIPS VIRTUAL?</div>
                        <div class="icon"></div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-1"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >KIPS Virtual is an online facility for students of
                        classes 9, 10, 1st year, 2nd year, and entry test
                        preparation, where they can purchase courses and learn
                        online through video lectures, readings, tests, and
                        teacher support.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-2 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>
                          Which browser is recommended for using KIPS VIRTUAL?
                        </div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-2"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >The updated version of Google Chrome is recommended for
                        KIPS Virtual. However, Microsoft Edge, Mozilla FireFox
                        and Safari also support KIPS Virtual.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-3 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>
                          Which mobile OS version is recommended for using KIPS
                          VIRTUAL App?
                        </div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-3"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >Android devices need to have 6.0 or above and IOS
                        devices need to have 11.0 or above for a hassle-free
                        experience.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-4 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>
                          Are there any specific requirements of Internet
                          Connection for KIPS VIRTUAL?
                        </div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-4"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >High speed uninterrupted internet connection is
                        required for attempting tests, watching videos and
                        readings, and using all other features without any
                        hindrance. (3G connection or above is recommended for
                        mobile users)
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
              <div class="acrBox">
                <h4>KIPS Virtual Accounts</h4>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-5 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>
                          What do I do if I forget my student account password?
                        </div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-5"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >In case you forget your password, click the "Forgot
                        Password" link on the login page. After entering your
                        username, your new password will be sent to your
                        registered contact number.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-6 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>
                          How do I recover my student account in case I forget
                          my username?
                        </div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-6"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >Send an Email to
                        <a href="mailto:support@kipsvirtual.com"
                          >support@kipsvirtual.com</a
                        >. Your credentials (username and password) will be sent
                        to your registered contact number.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-7 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>
                          How long does my student account remain valid?
                        </div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-7"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >Once you have signed up, your account remains valid for
                        as long as you wish to keep it.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
              <div class="acrBox">
                <h4>How To's</h4>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-8 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>
                          How do I attempt tests, watch videos, and view
                          readings?
                        </div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-8"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >When you click on a subject's tab on "My Programs"
                        page, you will find readings, videos, tests,and
                        assignments. Alternatively, you can search for your
                        desired videos and readings.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-9 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>
                          How do I report a mistake I find in a question, its
                          answer, or in readings and videos etc.?
                        </div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-9"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >You can report a mistake by clicking on the "Report"
                        icon in videos, readings, tests, and assignments.
                        Alternatively, you may share the details of the mistake
                        through teacher support, or through email to
                        <a href="mailto:support@kipsvirtual.com"
                          >support@kipsvirtual.com</a
                        ></b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
              <div class="acrBox">
                <h4>Support</h4>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-10 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>What is teacher support?</div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-10"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >This feature of KIPS Virtual enables you to chat with
                        subject experts to find instant answers to your
                        queries.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-11 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>How do I access teacher support?</div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-11"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >You can access chat from the Subject page or through
                        the Teacher Support link in the left menu.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-12 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>At what times is teacher support available?</div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-12"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >Teacher Support is available on working days between 9
                        am and 9 pm.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-13 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>How do I contact KIPS Virtual support team?</div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-13"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >Send an email to
                        <a href="mailto:support@kipsvirtual.com"
                          >support@kipsvirtual.com</a
                        >. Your queries will be catered within 48
                        hours.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-14 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>How can I view my progress in my programs?</div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-14"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >You will find a 'Stats' link in the left menu. From
                        there, you can view a graphical representation of the
                        extent to which you have completed the course of each
                        subject in each of your programs, along with your result
                        in each test.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-15 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>
                          How can I know where I stand in my current session in
                          comparison to other LMS users?
                        </div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-15"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >You will find a 'Leaderboard' link in the left menu.
                        From there, you can view the top 20 positions among the
                        students of your program.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
              <div class="acrBox">
                <h4>Registration & Sessions (Campus Students Only)</h4>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-16 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>
                          How do I get registered for KIPS Campus Sessions?
                        </div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-16"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >To get a student account, you need to get yourself
                        registered at a KIPS Campus or visit
                        <a href="https://kips.edu.pk/" target="_blank"
                          >kips.edu.pk</a
                        >. Please note that all sessions are not available on
                        KIPS VIRTUAL. For details, please contact the relevant
                        Campus Manager.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-17 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>
                          How do I get Username and Password for the student
                          account?
                        </div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-17"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >If your session is available on KIPS VIRTUAL, your
                        username and password will be sent within 48 hours to
                        the contact number you provided when getting
                        registered.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-18 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>Which sessions are available on KIPS Virtual?</div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-18"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >Contact your Campus manager for information regarding
                        the availability of a session. Not all sessions
                        conducted in campuses are available on KIPS
                        Virtual.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-2" style="position: relative">
                  <b-card-header header-tag="header" role="tab">
                    <div block v-b-toggle.accordion-19 variant="info">
                      <div class="d-flex justify-content-between">
                        <div>
                          What do I do if I get registered to the wrong program?
                          How do I change the registered program?
                        </div>
                        <div class="icon">
                          <!-- <div class="plus">+</div>
                        <div class="minus">-</div> -->
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-19"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text
                        >You need to provide all the details to the campus
                        manager, after whose approval, your program will be
                        changed accordingly.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <appFooter />

    <!-- <app-footer></app-footer> -->
  </div>
</template>

<script>
import footer from "../layout/landing/appFooter.vue";
import pageHeader from "../components/pageHeader.vue";

export default {
  components: {
    appFooter: footer,
    pageHeader,
  },
  metaInfo: {
    title: "FAQ | KIPS VIRTUAL",
    // meta: [
    //   {
    //     name: "description",
    //     content:
    //       "Epiloge is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
    //   },
    //   {
    //     property: "og:title",
    //     content: "Epiloge - Build your network in your field of interest",
    //   },
    // ],
    titleTemplate: "",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  computed: {},
  asyncData({ store, route }) {},
  created() {},
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {},
};
</script>
